/**
 * Search Icon Component
 *
 * @return {*}
 */
export const SearchIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1473_4835)">
                <path
                    d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
                    stroke="#0C1231"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21 21L15 15"
                    stroke="#0C1231"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

/**
 * Quote Icon Component
 *
 * @return {*}
 */
export const QuoteIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="39"
            height="30"
            viewBox="0 0 39 30"
            fill="none">
            <path
                opacity="0.4"
                d="M0 30V21.4165C0 18.9481 0.460301 16.3815 1.3809 13.7167C2.3294 11.0238 3.61266 8.48527 5.23069 6.10098C6.87661 3.68864 8.71781 1.65498 10.7543 0L17.7843 4.58625C16.1384 7.08275 14.7575 9.69144 13.6416 12.4123C12.5536 15.1052 12.0236 18.0785 12.0515 21.3324V30H0ZM21.2157 30V21.4165C21.2157 18.9481 21.676 16.3815 22.5966 13.7167C23.5451 11.0238 24.8283 8.48527 26.4464 6.10098C28.0923 3.68864 29.9335 1.65498 31.97 0L39 4.58625C37.3541 7.08275 35.9732 9.69144 34.8573 12.4123C33.7693 15.1052 33.2393 18.0785 33.2672 21.3324V30H21.2157Z"
                fill="#F5691C"
            />
        </svg>
    );
};

/**
 * Arrow Down Icon Component
 *
 * @return {*}
 */
export const ArrowDownIcon = ({ color = '#868998' }) => {
    return (
        <svg
            className="inline"
            width="13"
            height="8"
            viewBox="0 0 13 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.5 1.375L6.25 6.625L1 1.375"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};
